import { render, staticRenderFns } from "./TranslationsKeyValuePairRow.vue?vue&type=template&id=17fa7bdf&scoped=true&"
import script from "./TranslationsKeyValuePairRow.vue?vue&type=script&lang=ts&"
export * from "./TranslationsKeyValuePairRow.vue?vue&type=script&lang=ts&"
import style0 from "./TranslationsKeyValuePairRow.vue?vue&type=style&index=0&id=17fa7bdf&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fa7bdf",
  null
  
)

export default component.exports